import React from "react";

const DayAttackResult = ({ stars, percentage }) => {
  return (
    <div className="flexrow">
      <img
        src={"stars/star" + stars + ".png"}
        alt={"Stars: " + stars}
        width="30px"
        height="13px"
        style={{ paddingRight: "5px" }}
      />
      <div>{percentage + "%"}</div>
    </div>
  );
};

const DayMissedAttack = () => {
  return (
    <div className="flexrow">
      <img
        src={"alert.png"}
        alt={"alert"}
        width="14px"
        height="14px"
        style={{ paddingRight: "5px" }}
      />
      <div>missed</div>
    </div>
  );
};

// Custom tooltip component
const DayTooltip = ({ data, position }) => {
  if (!data) return null;
  var attack1 =
    data.day.attacks > 0 ? (
      <DayAttackResult
        stars={
          data.day.attacks === 2 ? data.day.stars >> 3 : data.day.stars % 8
        }
        percentage={
          data.day.attacks === 2 ? data.day.perc >> 7 : data.day.perc % 128
        }
      />
    ) : (
      <DayMissedAttack />
    );
  var attack2 = null;
  if (data.war.numAttacks === 2) {
    attack2 =
      data.day.attacks > 1 ? (
        <DayAttackResult
          stars={data.day.stars % 8}
          percentage={data.day.perc % 128}
        />
      ) : (
        <DayMissedAttack />
      );
  }

  return (
    <div
      className="daytooltip"
      style={{ top: position.top, left: position.left }}
    >
      {attack1}
      {attack2}
    </div>
  );
};

export default DayTooltip;
